var $3a572e5fc81706d7$exports = {};
$3a572e5fc81706d7$exports = {
    "backButton": (args)=>`Sp\xe4\u{165} na ${args.prevMenuButton}`,
    "moreActions": `\u{10E}al\u{161}ie akcie`,
    "unavailable": `Nedostupn\xe9, rozba\u{13E}te podrobnosti`
};


export {$3a572e5fc81706d7$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
